import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Box,
} from "@mui/material";

interface Props {
  open: boolean;
  onClose: () => void;
  filters: any;
  setFilters: (val: any) => void;
  onApply: (val: any) => void;
  onReset: () => void;
}

const STATUS = {
  USER_NOT_FOUND: 1,
  DEVICE_ID_MISSING: 2,
  FCM_TOKEN_MISSING: 3,
  PUSH_FAILED: 4,
  SUCCESS: 5,
  PERMANENT_FAILURE: 6,
};

const NotificationFilterDialog = ({
  open,
  onClose,
  filters,
  setFilters,
  onApply,
  onReset,
}: Props) => {
  const [localFilters, setLocalFilters] = useState(filters);

  // sync when dialog opens or filters change externally
  useEffect(() => {
    if (open) {
      setLocalFilters(filters);
    }
  }, [open, filters]);

  const handleChange = (key: string, value: any) => {
    setLocalFilters((prev: any) => ({
      ...prev,
      [key]: value,
    }));
  };

  const handleApply = () => {
    setFilters(localFilters);   // update parent only on apply
    onApply(localFilters);
    onClose();
  };

  const handleReset = () => {
    const reset = {
      dateFrom: "",
      dateTo: "",
      status: "",
      sortOrder: "DESC",
    };

    setLocalFilters(reset);
    setFilters(reset);
    onReset();
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Filter Notification Logs</DialogTitle>

      <DialogContent dividers>
        <Box display="flex" flexDirection="column" gap={2} mt={1}>
          {/* DATE FROM */}
          <TextField
            label="Date From"
            type="date"
            InputLabelProps={{ shrink: true }}
            value={localFilters.dateFrom || ""}
            onChange={(e) => handleChange("dateFrom", e.target.value)}
          />

          {/* DATE TO */}
          <TextField
            label="Date To"
            type="date"
            InputLabelProps={{ shrink: true }}
            value={localFilters.dateTo || ""}
            onChange={(e) => handleChange("dateTo", e.target.value)}
          />

          {/* STATUS */}
          <FormControl fullWidth>
            <InputLabel>Status</InputLabel>

            <Select
              value={localFilters.status || ""}
              label="Status"
              onChange={(e) =>
                handleChange("status", e.target.value)
              }
            >
              <MenuItem value="">All</MenuItem>

              {Object.entries(STATUS).map(
                ([label, value]) => (
                  <MenuItem key={value} value={value}>
                    {label.replace(/_/g, " ")}
                  </MenuItem>
                )
              )}
            </Select>
          </FormControl>

          {/* SORT ORDER */}
          <FormControl fullWidth>
            <InputLabel>Sort Order</InputLabel>
            <Select
              value={localFilters.sortOrder || "DESC"}
              label="Sort Order"
              onChange={(e) => handleChange("sortOrder", e.target.value)}
            >
              <MenuItem value="DESC">Newest First</MenuItem>
              <MenuItem value="ASC">Oldest First</MenuItem>
            </Select>
          </FormControl>
        </Box>
      </DialogContent>

      <DialogActions>
        <Button onClick={handleReset}>Reset</Button>
        <Button onClick={onClose}>Close</Button>
        <Button variant="contained" onClick={handleApply}>
          Apply
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default NotificationFilterDialog;